<template>
  <div class="jumbotron">
    <h1 class="display-4">Complete</h1>
    <hr class="my-4">
    <!-- p class="lead">Thank you for completing this portion of our study! Please click Complete to continue.</p -->
    <p v-if="this.$route.params.result === 'failed_training'"> Thank you for your effort. You are done with this task.</p>
    <p v-else class="lead">Thank you for completing the task! </p>
    <p> Please click the Complete button. </p>
    <button
      type="button"
      class="btn btn-success"
      @click="complete">Complete</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['returnTo'])
  },
  methods: {
    complete () {
      // if there is a returnTo, navigate to this url when the participant clicks complete
      if (this.returnTo && this.returnTo.length) {
        window.location.href = this.returnTo
      }
    }
  },
  created() {
    this.$store.dispatch('sendCompletionMessage')
  }
}
</script>
